require('./bootstrap');
require('./sliders/srcipts.js');
require('./scripts');
require('./access');

window.Cart = require('./components/cart/cart.js').default;

import Vue, {createApp} from "vue";

import TUser from './components/customer/common.vue'
import TCart from './components/cart/cart.vue'
import TSearch from './components/search/search'
import TSearchMenu from './components/search/search-menu.vue'
import TContact from './components/contact/footer'
import TRegister from './components/customer/register'
import PageCheckout from './components/checkout/checkout.vue'
import PersonalInfo from './components/customer/personal-info'
import ProductModal from './../../common/components/product/product-modal'


document.addEventListener('DOMContentLoaded', () => {
  document.cookie = 'screen_size=' + screen.width + ';';
  if (document.getElementById('header-user')) {
    const app = createApp({
      components: {
        TUser
      },
      data: function () {
        return {}
      },
      methods: {
        show() {
          this.$refs.uu.show();
        }
      },
      template: "<t-user ref='uu'></t-user>"
    })
    window.userModal = app.mount('#header-user')

    window.addEventListener('openLoginModal', function () {
      window.userModal.show();
    })

    if (document.querySelector('#menu-login-register-button')) {
      document.querySelector('#menu-login-register-button').addEventListener('click', function (e) {
        e.preventDefault()
        document.querySelector('.header-menu').classList.remove('active')
        window.userModal.show()
      })
    }
  }
  if (document.getElementById('register-page')) {
    const app = createApp({
      components: {
        TRegister
      },
      data: function () {
        return {}
      },
      template: "<t-register></t-register>"
    })
    app.mount('#register-page')
  }
  if (document.getElementById('header-cart')) {
    const app = createApp({
      components: {
        TCart
      },
      data: function () {
        return {}
      },
      template: "<t-cart></t-cart>"
    })
    app.mount('#header-cart')
  }

  if (document.getElementById('header-search')) {
    const app = createApp({
      components: {
        TSearch
      },
      data: function () {
        return {}
      },
      template: "<t-search></t-search>"
    })
    app.mount('#header-search')
  }

  if (document.getElementById('header-menu-search')) {
    const app = createApp({
      components: {
        TSearchMenu
      },
      data: function () {
        return {}
      },
      template: "<t-search-menu></t-search-menu>"
    })
    app.mount('#header-menu-search')
  }

  if (document.getElementById('footer-contact')) {
    const app = createApp({
      components: {
        TContact
      },
      data: function () {
        return {}
      },
      template: "<t-contact></t-contact>"
    })
    app.mount('#footer-contact')
  }
  if (document.getElementById('page-checkout-container')) {
    const app = createApp({
      components: {
        PageCheckout
      },
      data: function () {
        return {}
      },
      template: "<page-checkout/>"
    })

    app.component('PaymentZcreditCardData', require('@/components/checkout/payments/data/zcredit-data.vue').default)

    app.mount('#page-checkout-container')
  }
  if (document.getElementById('customer-personal')) {
    const app = createApp({
      components: {
        PersonalInfo
      },
      data: function () {
        return {}
      },
      template: "<personal-info/>"
    })
    app.mount('#customer-personal')
  }

  $('.customer-addresses__filled .ca-delete').click(function () {
    const id = $(this).data('id');
    $.ajax(route('client.customer.addresses.destroy', {address: id}), {
      method: 'DELETE',
      success: function () {
        window.location.reload();
      }

    })
  })

  $('.customer-addresses__filled .ca-default').click(function (e) {
    const id = $(this).data('id');
    $.ajax(route('client.customer.addresses.set-default', {address: id}), {
      method: 'POST',
    })
  })

  const prodModal = createApp({
    components: {
      ProductModal
    },
    data: function () {
      return {}
    },
    template: "<product-modal ref='pm' @selected='onProductAdd'/>",
    methods: {
      showModal(product_id) {
        this.$refs.pm.show(product_id)
      },
      onProductAdd(data) {
        Cart.add({
          product_id: data.data?.variant?.product_id || data.product_id,
          variant_id: data.data?.variant?.variant_id,
          options: data.data?.options,
          quantity: 1,
          strings: data?.strings
        })
        let breadcrumbs = null;
        let cat = null;
        breadcrumbs = document.querySelector('.breadcrumbs')
        if(breadcrumbs) {
          cat = ''
          for(let i = 0; i < breadcrumbs.children.length; i++) {
            cat += breadcrumbs.children[i].children[0].innerText + ' | ';
          }
          cat = cat.substr(0, cat.length - 3);
        }
        const category = cat ? cat : data.category;
        dataLayer = dataLayer || [];
        dataLayer.push({ ecommerce: null });
        dataLayer.push({
          event: "add_to_cart",
          ecommerce: {
            items: [{
              item_name: data.name,
              item_id: data.article,
              price: data.price,
              item_brand: "Babolat",
              item_category: category,
              quantity: 1
            }]
          }
        });
      },
    }
  })
  window.prodModal = prodModal.mount('#pam')

  document.addEventListener('click', function (e) {
   // const path = e.path || (e.composedPath && e.composedPath())
    const path = (e.composedPath && e.composedPath())
    const el = path.find(e => e.classList && e.classList.contains('product__item-cart'))
    if (el) {
      window.prodModal.showModal(+el.dataset.pmid)
    }
  })


  document.addEventListener('click', function (e) {
    //const path = e.path || (e.composedPath && e.composedPath())
    const path = (e.composedPath && e.composedPath())
    const more = path.find(e => e.classList && e.classList.contains('product__item__colors__more'))
    /*if (more) {
      const colors = more.closest('.product__item__colors')
      colors.classList.toggle('show')
    }*/
  })

  let original_img = false;
  let original_img_sec = false;
  let original_pcolor = false;
  let original_path = false;
  let original_prod = false;

  document.addEventListener('mouseover', function (e) {
    //const path = e.path || (e.composedPath && e.composedPath())
    const path = (e.composedPath && e.composedPath())
    const pcolor = path.find(e => e.classList && e.classList.contains('product__item__colors__item'))
    if (pcolor) {
      const prod = pcolor.closest('.product__item')
      const img = prod.querySelector('.product__item--image')
      const second = prod.querySelector('.product__item--image-hover')
      img.src = pcolor.dataset.pi
      second.src = pcolor.dataset.sec

      for (const pc of Array.from(prod.querySelectorAll('.product__item__colors__item'))) {
        pc.classList.remove('active')
        pcolor.classList.add('active')
      }

      for (const link of Array.from(prod.querySelectorAll('a'))) {
        link.href = pcolor.dataset.link
      }
    }
  });

  document.querySelectorAll('.product__item__colors__item.main-data-img.active').forEach(function (element) {
    element.addEventListener('mouseover', function () {
      console.log('Event triggered');
    });

    let event = new MouseEvent('mouseover', {
      'view': window,
      'bubbles': true,
      'cancelable': true
    });
    element.dispatchEvent(event);
  });

/*let links = document.getElementsByClassName('product__item-name');
  Array.from(links).forEach((link) => {
    link.addEventListener('click', function (e) {
      console.log(window.product)
      setTimeout(function () {
        dataLayer.push({ ecommerce: null });
        dataLayer.push({
          event: "select_item",
          ecommerce: {
            items: [{
              item_name: window.product.name,
              item_id: window.product.article,
              price: window.product.price,
              item_brand: "Babolat",
              item_category: window.product.category,
              quantity: 1
            }]
          }
        });
        console.log(window.product)
      }, 300)
    })
  })*/

  document.addEventListener('mouseout', function (e) {
    const path = (e.composedPath && e.composedPath())
    const pcolor = path.find(e => e.classList && e.classList.contains('product__item__colors__item'))
    if (pcolor) {
      const prod = pcolor.closest('.product__item')
      const origin = prod.querySelector('.main-data-img')
      const img = prod.querySelector('.product__item--image')
      const second = prod.querySelector('.product__item--image-hover')
      img.src = origin.dataset.pi
      second.src = origin.dataset.sec

      for (const pc of Array.from(prod.querySelectorAll('.product__item__colors__item'))) {
        pc.classList.remove('active')
        origin.classList.add('active')
      }

      for (const link of Array.from(prod.querySelectorAll('a'))) {
        link.href = origin.dataset.link
      }
    }
  })

  document.addEventListener('click', function (e) {
    //const path = e.path || (e.composedPath && e.composedPath())
    const path = (e.composedPath && e.composedPath())
    const el = path.find(e => e.classList && e.classList.contains('product__item-color'))
    if (el) {
      window.prodModal.showModal(+el.dataset.pmid)
    }
  })

  // document.querySelector('#footer-contact-show').addEventListener('click', function (e) {
  //   e.target.style.display = 'none'
  //   document.querySelector('#footer-contact form').classList.add('show')
  // })
})

let checkExist = setInterval(function () {
  /*if ($('.custom-select').length) {
    var x, i, j, l, ll, selElmnt, a, b, c;
    x = document.getElementsByClassName("custom-select");
    l = x.length;
    for (i = 0; i < l; i++) {
      if(x[i].classList.contains('custom-select-init')) {
        continue;
      }
      selElmnt = x[i].getElementsByTagName("select")[0];
      x[i].classList.add("custom-select-init");
      ll = selElmnt.length;
      a = document.createElement("DIV");
      a.setAttribute("class", "select-selected");
      a.innerHTML = selElmnt.options[selElmnt.selectedIndex]?.innerHTML??selElmnt.options[0].innerHTML;
      x[i].appendChild(a);
      b = document.createElement("DIV");
      b.setAttribute("class", "select-items select-hide");
      for (j = 0; j < ll; j++) {
        c = document.createElement("DIV");
        c.innerHTML = selElmnt.options[j].innerHTML;
        c.addEventListener("click", function (e) {
          var y, i, k, s, h, sl, yl;
          s = this.parentNode.parentNode.getElementsByTagName("select")[0];
          sl = s.length;
          h = this.parentNode.previousSibling;
          for (i = 0; i < sl; i++) {
            if (s.options[i].innerHTML == this.innerHTML) {
              s.selectedIndex = i;
              h.innerHTML = this.innerHTML;
              y = this.parentNode.getElementsByClassName("same-as-selected");
              yl = y.length;
              for (k = 0; k < yl; k++) {
                y[k].removeAttribute("class");
              }
              this.setAttribute("class", "same-as-selected");
              break;
            }
          }
          h.click();
          const event = new Event('change');
          h.closest('.custom-select').querySelector('select').dispatchEvent(event);
        });
        b.appendChild(c);
      }
      x[i].appendChild(b);
      a.addEventListener("click", function (e) {
        e.stopPropagation();
        closeAllSelect(this);
        this.nextSibling.classList.toggle("select-hide");
        this.classList.toggle("select-arrow-active");
      });
    }

    function closeAllSelect(elmnt) {
      var x, y, i, xl, yl, arrNo = [];
      x = document.getElementsByClassName("select-items");
      y = document.getElementsByClassName("select-selected");
      xl = x.length;
      yl = y.length;
      for (i = 0; i < yl; i++) {
        if (elmnt == y[i]) {
          arrNo.push(i)
        } else {
          y[i].classList.remove("select-arrow-active");
        }
      }
      for (i = 0; i < xl; i++) {
        if (arrNo.indexOf(i)) {
          x[i].classList.add("select-hide");
        }
      }
    }

    document.addEventListener("click", closeAllSelect);
    //clearInterval(checkExist);
  }*/

}, 100);
